import { playgroundApi } from '../../common/api-client';
import { BaseSavingsInsuranceResponse } from '../_shared';
import { LifeMaxFormValues } from './schema';

export const PRODUCT = 'LIFE_MAX';

export interface InitialContributionBreakdown {
  total: number;
  basic: number;
  excess: number;
}

export type LifeMaxResponse = BaseSavingsInsuranceResponse & {
  initial_contribution: InitialContributionBreakdown;
};

export interface SimulateParams {
  values: LifeMaxFormValues;
}

export async function simulateLifeMax({
  values,
}: SimulateParams): Promise<LifeMaxResponse> {
  const payload = {
    product: PRODUCT,
    origin_process_id: `playground-${crypto.randomUUID().slice(0, 8)}`,
    ...values,
    debug: true,
  };
  const { data } = await playgroundApi.post<LifeMaxResponse>('projection/', payload);
  return data;
}
